import React, { useRef, useState, useEffect } from "react";
import { Modal } from "../../../components/ui/Modal";
import { Pill } from "../../../components/ui/Pill";

interface CameraModalProps {
  onCapture: (imgB64: string) => void;
  onClose: () => void;
}

export function CameraModal({ onCapture, onClose }: CameraModalProps) {
  const vR = useRef<HTMLVideoElement>(null);
  const cR = useRef<HTMLCanvasElement>(null);
  const sR = useRef<MediaStream | null>(null);
  const [rdy, setRdy] = useState(false);
  const [cap, setCap] = useState<string | null>(null);

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: "environment" } })
      .then((st) => {
        sR.current = st;
        if (vR.current) { vR.current.srcObject = st; setRdy(true); }
      })
      .catch(() => {});
    return () => sR.current?.getTracks().forEach((t) => t.stop());
  }, []);

  const snap = () => {
    const v = vR.current, c = cR.current;
    if (!v || !c) return;
    c.width = v.videoWidth;
    c.height = v.videoHeight;
    c.getContext("2d")!.drawImage(v, 0, 0);
    setCap(c.toDataURL("image/jpeg", 0.85));
    sR.current?.getTracks().forEach((t) => t.stop());
  };

  return (
    <Modal onClose={onClose} title="Photographier l'étiquette">
      <div className="rounded-md overflow-hidden mb-3 bg-black min-h-[180px] flex items-center justify-center">
        {cap
          ? <img src={cap} alt="Photo capturée" className="w-full" />
          : <video ref={vR} autoPlay playsInline className="w-full" />}
        <canvas ref={cR} className="hidden" />
      </div>
      <div className="flex gap-2">
        {!cap ? (
          <Pill active disabled={!rdy} onClick={snap} style={{ flex: 1 }}>{rdy ? "Capturer" : "Caméra…"}</Pill>
        ) : (
          <>
            <Pill onClick={() => setCap(null)} style={{ flex: 1 }}>Reprendre</Pill>
            <Pill active onClick={() => onCapture(cap.split(",")[1])} style={{ flex: 2 }}>Analyser →</Pill>
          </>
        )}
      </div>
    </Modal>
  );
}
